// extracted by mini-css-extract-plugin
export default {"mainCard":"Category_mainCard__v5kUY","mainImg":"Category_mainImg__+KBiZ","imgTitle":"Category_imgTitle__l-Mks"};